<template>
    <base-dialog @cancel="cancelDialog">
      <div slot="header">{{ $t('bill.report_sub') }}</div>
      <div slot="body">
        <a-form :form="form.fc" v-bind="formItemLayout" hideRequiredMark>
          <a-form-item :label="$t('bill.report_sub_type')">
            <a-radio-group v-decorator="decorators.type">
              <a-radio-button
                v-for="item in BILL_TYPES"
                :value="item.key"
                :key="item.key">{{ item.value }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t('bill.cycle_type')">
            <a-radio-group v-decorator="decorators.cycle_type">
              <a-radio-button v-for="v in PERIOD_TYPES" :key="v.key" :value="v.key">{{v.value}}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t('bill.cycle_type_week')" v-if="form.fc.getFieldValue('cycleTimer.cycle_type') === 'week'">
            <a-select v-decorator="decorators.weekDays">
              <a-select-option v-for="(v, k) in $t('flexGroupSubCycleTypeWeek')" :key="k" :value="parseInt(k)">{{v}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('bill.cycle_type_day')" v-if="form.fc.getFieldValue('cycleTimer.cycle_type') === 'month'">
            <a-select v-decorator="decorators.monthDays">
              <a-select-option v-for="i in 31" :key="i" :value="parseInt(i)">{{$t('cloudenv.text_436', [i])}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('bill.cycle_type_time')">
            <a-time-picker v-decorator="decorators.hourMinute" format="HH:mm" />
          </a-form-item>
          <a-form-item class="mb-0" :label="$t('bill.report_email')" :extra="$t('bill.report_email_tips')">
            <a-textarea
              v-decorator="decorators.emails"
              :auto-size="{ minRows: 2, maxRows: 6 }" />
          </a-form-item>
          <a-form-item :wrapperCol="{ offset: 5 }">
            <a-checkbox v-decorator="decorators.start_run">{{ $t('bill.report_start_run') }}</a-checkbox>
          </a-form-item>
        </a-form>
      </div>
      <div slot="footer">
        <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
        <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
      </div>
    </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { BILL_TYPES, PERIOD_TYPES } from '../constants'

export default {
  name: 'BillReportSubDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      BILL_TYPES,
      PERIOD_TYPES,
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        type: [
          'type',
          {
            initialValue: 'month',
          },
        ],
        cycle_type: [
          'cycleTimer.cycle_type',
          {
            initialValue: 'day',
            rules: [
              { required: true, message: this.$t('cloudenv.text_443') },
            ],
          },
        ],
        weekDays: [
          'cycleTimer.week_days',
          {
            initialValue: 1,
            rules: [
              { required: true, message: this.$t('cloudenv.text_444') },
            ],
          },
        ],
        monthDays: [
          'cycleTimer.month_days',
          {
            initialValue: 4,
            rules: [
              { required: true, message: this.$t('cloudenv.text_445') },
            ],
          },
        ],
        // 小时：分钟
        hourMinute: [
          'hourMinute',
          {
            initialValue: this.$moment({ hour: 8 }),
            rules: [
              { required: true, message: this.$t('cloudenv.text_446') },
            ],
          },
        ],
        emails: [
          'emails',
          {
            rules: [
              { validator: this.validateEmails },
            ],
          },
        ],
        start_run: [
          'start_run',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      curCostReport: {},
    }
  },
  computed: {
    ...mapGetters(['scope']),
  },
  created () {
    this.costreportsManager = new this.$Manager('costreports', 'v1')
    this.fetchData()
  },
  methods: {
    fetchData () {
      const params = { scope: this.scope }
      this.costreportsManager.list({ params })
        .then(res => {
          if (res.data.data && res.data.data.length > 0) {
            this.curCostReport = res.data.data[0]
            const { period_type, colon_timer, emails = [], day } = this.curCostReport
            const formData = {
              cycleTimer: {
                cycle_type: period_type,
              },
              hourMinute: this.$moment(colon_timer, 'HH:mm'),
            }
            if (emails && emails.length > 0) {
              formData.emails = emails.join('\n')
            }
            this.$nextTick(() => {
              this.form.fc.setFieldsValue(formData)
            })
            setTimeout(() => {
              this.form.fc.setFieldsValue({
                cycleTimer: {
                  week_days: day,
                  month_days: day,
                },
              })
            }, 0)
          }
        })
    },
    doUpdate (data) {
      return this.costreportsManager.update({
        id: this.curCostReport.id,
        data,
      })
    },
    doCreate (data) {
      return this.costreportsManager.create({
        data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const { cycleTimer, hourMinute, emails = '', start_run = false } = await this.form.fc.validateFields()
        const params = {
          period_type: cycleTimer.cycle_type,
          colon_timer: hourMinute.format('HH:mm'),
          scope: this.scope,
          start_run: start_run,
          emails: [],
        }
        if (emails) {
          params.emails = emails.split('\n')
        }
        if (cycleTimer.cycle_type === 'week') {
          params.day = cycleTimer.week_days
        } else if (cycleTimer.cycle_type === 'month') {
          params.day = cycleTimer.month_days
        }
        if (!this.curCostReport.id) {
          await this.doCreate(params)
        } else {
          await this.doUpdate(params)
        }
        this.cancelDialog()
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
    validateEmails (rule, value, callback) {
      if (value) {
        const isOk = value.split('\n').every(v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(v))
        if (isOk) {
          callback()
        } else {
          callback(new Error(this.$t('validator.email')))
        }
      }
      callback()
    },
  },
}
</script>
